import { LoginsPhoneModel } from 'src/app/hickory-api';

export interface LoginPhoneTypeMenuItem {
  type: LoginsPhoneModel.TypeEnum;
  description: string;
  localizationKey?: string;
  icons?: string[];
}

export class ContactPhonesHelper {
  static readonly defaultPhonePriority: string[] = [
    LoginsPhoneModel.TypeEnum.Cell,
    LoginsPhoneModel.TypeEnum.Business,
    LoginsPhoneModel.TypeEnum.Home,
  ];

  static readonly phonePriorityMapping = {
    [LoginsPhoneModel.TypeEnum.Cell]: 1,
    [LoginsPhoneModel.TypeEnum.Business]: 2,
    [LoginsPhoneModel.TypeEnum.Home]: 3,
  };

  static readonly sortOrder = {
    [LoginsPhoneModel.TypeEnum.Cell]: 1,
    [LoginsPhoneModel.TypeEnum.Pager]: 2,
    [LoginsPhoneModel.TypeEnum.Home]: 3,
    [LoginsPhoneModel.TypeEnum.Business]: 4,
    [LoginsPhoneModel.TypeEnum.Fax]: 5,
  };

  static readonly typeNameMap = {
    [LoginsPhoneModel.TypeEnum.Business]: 'Business Phone',
    [LoginsPhoneModel.TypeEnum.Cell]: 'Cell Phone',
    [LoginsPhoneModel.TypeEnum.Fax]: 'Fax',
    [LoginsPhoneModel.TypeEnum.Home]: 'Home Phone',
    [LoginsPhoneModel.TypeEnum.Pager]: 'Pager/2nd Cell Phone',
  };

  /**
   * Gets all phone types that are valid for contact phones (excludes Fax)
   */
  static getContactPhoneTypes(): LoginsPhoneModel.TypeEnum[] {
    return Object.values(LoginsPhoneModel.TypeEnum).filter((t) => t !== LoginsPhoneModel.TypeEnum.Fax);
  }

  /**
   * Gets the available phone types that haven't been used yet for a contact
   * Filters out Fax and any types already in use
   */
  static getAvailableContactPhoneTypes(listData?: LoginsPhoneModel[]): LoginsPhoneModel.TypeEnum[] {
    const currentTypes = listData?.map((item) => item.type) ?? [];
    return this.getContactPhoneTypes().filter((enumValue) => !currentTypes.includes(enumValue));
  }

  static supportsSms(type: LoginsPhoneModel.TypeEnum): boolean {
    return type === LoginsPhoneModel.TypeEnum.Cell || type === LoginsPhoneModel.TypeEnum.Pager;
  }

  static supportsVoice(type: LoginsPhoneModel.TypeEnum): boolean {
    return (
      type === LoginsPhoneModel.TypeEnum.Cell ||
      type === LoginsPhoneModel.TypeEnum.Business ||
      type === LoginsPhoneModel.TypeEnum.Home
    );
  }

  static sortPhones(phones: LoginsPhoneModel[]): LoginsPhoneModel[] {
    return phones.sort((a: LoginsPhoneModel, b: LoginsPhoneModel) => {
      return (
        (this.sortOrder[a.type as keyof typeof this.sortOrder] ?? 0) -
        (this.sortOrder[b.type as keyof typeof this.sortOrder] ?? 0)
      );
    });
  }
}
